module.exports = __webpack_public_path__ + "static/img/10.56f9a07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/benjyfishy/10.png
// module id = mqoD
// module chunks = 35